var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-content-box"},[_c('infoBaseEl',{attrs:{"worksObj":_vm.worksObj}}),_c('infoWorksEl',{attrs:{"worksObj":_vm.worksObj}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }